import "./Solutions.css";
import Footer from "./Footer";
import solimg1 from "../assets/sol-img1.png";
import solimg2 from "../assets/sol-img2.png";


export default function SolDesign() {
    return (
        <section id="sol-des">
            {/* TOP SECTION */}
           <div className="lightweighting-wrapper-a">
    {/* LEFT CONTENT */}
    <div className="lightweighting-text-a">
        <h3>Design </h3>
        <h3>
            Lightweighting Through Design, Material, and Process Optimization
        </h3>

        <p>
            SCL delivers lightweight solutions through adequate material selection and alloy development, optimized design combined with the right manufacturing process. We support our customer to reach weight and efficiency targets through innovation and cutting edge technologies.

        </p>
    </div>

    
</div>

            <div className="img-grid">
                <img src={solimg1} alt="solutions" />
                <img src={solimg2} alt="solutions" />
            </div>


            <div className="dmp-wrapper-a">
                <div className="dmp-card">
                    <div className="dmp-header">
                        ⚙️ <span>Design</span>
                    </div>

                    <div className="dmp-body">
                        <h4>Focus</h4>
                        <p>
                            System thinking allows us to better understand components function for optimizing and creating improved customer value.
                        </p>

                        <h4>Tools & Technologies</h4>
                        <ul>
                            <li>
                                CAD modelling with design space consideration – Creo
                            </li>
                            <li>
                                Topological optimization and main load path creation – Hyperworks
                            </li>
                            <li>
                                Finite element analysis for strength, durability or crash assessment – Hyperworks
                            </li>
                        </ul>

                        <h4>Customer Benefits</h4>
                        <ul>
                            <li>Shortened development time</li>
                            <li>Cost benefits of an integrated casting through less interfaces, machining content and less material</li>
                            <li>Lightweight component contributes to higher fuel efficiency and lower CO2 footprint</li>
                            <li>Integrated casting will improve stiffness and NVH criterial to support for better driver comfort</li>
                        </ul>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        🧱 <span>Material</span>
                    </div>

                    <div className="dmp-body">
                        <h4>Focus</h4>
                        <p>
                            Our R&D Metallurgists support you in selecting the right alloy for the intended use of product.
                        </p>

                        <h4>Capabilities</h4>
                        <ul>
                            <li>
                                Alloy selection and -optimization designed for strength, durability and thermal requirements
                            </li>
                            <li>Focus on sustainable, low-CO₂ aluminium alloys</li>
                        </ul>

                        <h4>Customer Benefits</h4>
                        <ul>
                            <li>
                                Highly sustainable components, which are lighter, stronger and better in corrosion-resistance
                            </li>
                            <li>Tailored solutions aligned with required vehicle performance and CO₂ reduction targets</li>
                        </ul>
                    </div>
                </div>
                </div>
                <div className="dmp-wrapper-1">

                {/* CARD 3 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        🔧 <span>Process</span>
                    </div>

                    <div className="dmp-body">
                        <h4>Capabilities</h4>
                        <ul>
                            <li>
                                Full range of casting processes: HPDC, GDC and LPDC
                            </li>
                            <li>
                                Post-processing for corrosion protection and surface finish: ED coating, powder coating, alumina shot blasting
                            </li>
                            <li>Process simulation and analysis of predicted quality with Magmasoft</li>
                            <li>Abrasive Flow Machining (AFM) patented process for North America, Europe and India for improving surface finish on product application.</li>
                        </ul>

                        <h4>Customer Benefits</h4>
                        <ul>
                            <li>
                                One-stop-shop solution provider, thanks to large variety on processes
                            </li>
                            <li>Expertise generated from large product portfolio in different processes</li>
                            <li>High engine efficiency with lower fuel consumption and CO2 emissions reduction</li>
                        </ul>
                    </div>
                </div>
            </div>

            <Footer />
        </section>
    );
}
